import { Navigate, useNavigate } from 'react-router-dom';
import { PageLoader } from '@/layouts/components/PageLoader/PageLoader';
import {
  OceanOfferCard,
  OtherIncomeBanner,
  useLoanOffer,
} from '@/features/offer';
import { externalUrls } from '@/constants/urls';
import { routes } from '@/routes/routes';
import styles from './AlternativeOfferPage.module.scss';

/**
 * The preliminary credit the user chose has no final offer after the ANAF
 * check, but the other credit has: offered instead.
 */
export function AlternativeOfferPage() {
  const navigate = useNavigate();
  const {
    creditLineOffer,
    installmentOffer,
    proofOfIncomeRequired,
    isLoading,
  } = useLoanOffer(true);

  if (isLoading) {
    return <PageLoader />;
  }

  const offers = [
    creditLineOffer && { type: 'credit-line' as const, offer: creditLineOffer },
    installmentOffer && { type: 'installment' as const, offer: installmentOffer },
  ].filter((item) => !!item);

  if (offers.length === 0) {
    return <Navigate to={routes.application.base} replace />;
  }

  // The proof of income is uploaded on the web only when the offer asks for it.
  const handleProofOfIncome = () => {
    if (proofOfIncomeRequired) {
      navigate(routes.offer.proofOfIncome);
      return;
    }
    window.location.href = externalUrls.volt.appDownload;
  };

  return (
    <div className={styles.root}>
      <div className={styles.header}>
        <h1 className={styles.title}>
          Am găsit o altă opțiune
          <br />
          pentru tine 👇
        </h1>
        <div className={styles.description}>
          <p>
            În urma verificării veniturilor, creditul selectat nu poate fi
            aprobat.
          </p>
          <p>Dar avem o altă ofertă disponibilă pentru tine!</p>
        </div>
      </div>

      <div className={styles.offers}>
        {offers.map(({ type, offer }) => (
          <OceanOfferCard
            key={offer.id}
            type={type}
            amount={offer.creditLimit}
            numberOfRates={offer.numberOfRates}
            trackingId={`alternative_offer_details_${type}`}
            onDetailsClick={() =>
              navigate(routes.application.calculatorTab(type))
            }
          />
        ))}
        <OtherIncomeBanner
          trackingId="alternative_offer_proof_of_income"
          onClick={handleProofOfIncome}
        />
      </div>
    </div>
  );
}

export default AlternativeOfferPage;
